export {
  formatAddress,
  formatCompactCurrency,
  formatCompactNumber,
  formatCurrency,
  formatDateTime,
  formatNumber,
  formatPercent,
  formatQuantity,
  formatSignedPercent,
} from "./display-format";
import {
  formatCurrency,
  formatSignedPercent,
  type FormatCurrencyOptions,
} from "./display-format";

type UsdDisplayInput = number | string | null | undefined;

function toFiniteUsdDisplayNumber(value: UsdDisplayInput): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export function formatUsd(value: number | string | null | undefined): string {
  return formatCurrency(value);
}

export function formatUsdBalance(
  value: UsdDisplayInput,
  options?: Pick<
    FormatCurrencyOptions,
    "currency" | "fallback" | "showSign"
  > & {
    zeroEpsilon?: number;
  },
): string {
  const numericValue = toFiniteUsdDisplayNumber(value);
  if (numericValue === null) {
    return options?.fallback ?? "—";
  }

  const zeroEpsilon = options?.zeroEpsilon ?? 0.005;
  if (Math.abs(numericValue) < zeroEpsilon) {
    return formatCurrency(0, {
      currency: options?.currency,
      fallback: options?.fallback,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      showSign: options?.showSign,
    });
  }

  const minimumFractionDigits = Number.isInteger(Math.abs(numericValue))
    ? 0
    : 2;

  return formatCurrency(numericValue, {
    currency: options?.currency,
    fallback: options?.fallback,
    maximumFractionDigits: 2,
    minimumFractionDigits,
    showSign: options?.showSign,
  });
}

export function formatPercentChange(
  value: number | string | null | undefined,
): string {
  return formatSignedPercent(value, {
    fallback: "n/a",
  });
}
